import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';

export const content = css({
  tabletDown: {
    px: 16,
  },
});

/**
 * 히스토리 화면 필터 영역. 12개 히스토리 페이지가 모두 이 클래스를 쓴다.
 * 간격을 바꿀 일이 생기면 여기만 고치면 된다.
 *
 * 위아래 여백을 스스로 갖기 때문에 탭 바로 아래에 오든 다른 블록 아래에 오든 같은 간격이 나온다.
 * Panda는 다른 파일의 상수를 정적 해석하지 못해 값이 통째로 누락되므로,
 * 숫자를 export해서 공유하지 말고 이 클래스를 그대로 쓸 것.
 */
export const filterSection = flex({
  justify: 'flex-start',
  align: 'center',
  w: '100%',
  mt: { base: 16, tablet: 30 },
  mb: { base: 16, tablet: 30 },
  tabletDown: {
    flexDirection: 'column',
    // 필터 행 ↔ 액션 버튼
    gap: 16,
    alignItems: 'flex-start',
  },
});

/**
 * 히스토리 카드 리스트의 아이템 간격. 공용 CardList(@flipster/ui)는 16px인데
 * 히스토리에서만 12px을 쓴다. 공용 컴포넌트는 다른 화면(referral 등)도 쓰므로 건드리지 않는다.
 *
 * `!important`가 필요한 이유: 공용 쪽은 SCSS 모듈이라 Panda의 `@layer` 밖에 있고,
 * 레이어 밖 스타일은 특이도와 무관하게 레이어 안 스타일을 이긴다.
 */
export const cardListGap = css({ '& > li + li': { mt: '12px!' } });

export const left = flex({
  justify: 'flex-start',
  align: 'center',
  gap: 12,
  flex: 1,
});

export const description = css({
  textStyle: 'Text/L/Regular',
  color: 'content.default.level-3',
});

export const card = css({
  '& dt': {
    textStyle: 'Text/S/Regular',
    color: 'content.default.level-2',
  },
  '& dd': {
    textStyle: 'Text/M/Regular',
    color: 'content.default.level-5',
  },
});

export const horizontal = flex({
  justify: 'space-between',
  align: 'flex-start',
  w: '100%',
  '& + div': {
    mt: 8,
  },
});

export const vertical = css({
  w: '100%',
  '& + div': {
    mt: 16,
  },
  '& dt': {
    mb: 4,
  },
});

export const hLine = css({
  w: '100%',
  h: 1,
  m: '12px 0',
  bgColor: 'border.default.level-3',
  border: 'none',
});

export const fromToAmount = flex({
  align: 'center',
  justify: 'flex-start',
  gap: 8,
});

export const currencyStyle = flex({
  gap: 4,
  textStyle: 'Text/M/Regular',
});

export const intervalSelector = css({
  tablet: { maxW: '224px!' },
});

export const symbolRow = flex({
  justify: 'space-between',
  align: 'center',
  tabletDown: {
    mb: 12,
  },
});
